import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class ClientsCountersConverter implements JsonCustomConvert<ClientsCounters>{
	serialize() { }
	deserialize(data: any): ClientsCounters {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, ClientsCounters);
	}
}

@JsonObject("ClientsCounters")
export class ClientsCounters{
    @JsonProperty("totals", Number, true)
	totals: number = 0;
    @JsonProperty("verified", Number, true)
	verified: number = 0;
    @JsonProperty("marketing_consent", Number, true)
	marketing_consent: number = 0;
    @JsonProperty("profile_consent", Number, true)
	profile_consent: number = 0;
}

@JsonObject("ClientsCountersData")
export class ClientsCountersData extends BaseResponse {
	@JsonProperty("data", ClientsCountersConverter, true)
	data: ClientsCounters = new ClientsCounters;
}
